module.exports = __webpack_public_path__ + "img/電気回路_4_4_3.914dfbb7.png";